import Vue from 'vue'
import moment from 'moment'
import 'bootstrap/js/src/collapse.js'
import axios from 'axios'
import VueAxios from 'vue-axios'
import flightList from '../flightList/flightList.vue'
import briefSummary from 'core-lib/components/briefSummary/briefSummary.vue'
import {mapFields} from 'vuex-map-fields'
import {gsap, TimelineLite, Power4} from 'gsap'
import {CSSPlugin} from 'gsap/CSSPlugin'
import Affix from 'vue-affix'
import { get, cloneDeep } from 'lodash'
import promiseBuilder from '../../promises/promiseBuilder'
import { version } from '../../../package.json'

Vue.use(VueAxios, axios)
gsap.registerPlugin(CSSPlugin) // for build prod

export default {
	name: 'shopping',
	computed: {
		...mapFields([
			'search',
			'origin',
			'destination',
			'theFinalList',
			'theFinalReturnList']),
		lang: {
			get: function () {
				return this.locale ? this.locale : this.$i18n.locale
			}
		},
		currentFlights: {
			get: function () {
				return (this.flightSelected.flight && this.search.return_date && this.lookingForReturn) ? this.flightsReturn : this.flightsGoing
			}
		},
		actualDate: {
			get: function () {
				return moment(
					(this.flightSelected.flight && this.search.return_flight && this.lookingForReturn) ?
						this.search.return_date :
						this.search.departure_date, this.dateFormat
				)
			}
		}
	},
	components: {
		flightList,
		briefSummary
	},
	watch: {
		departure_date(val) {
			if (this.flightsGoing[0]) {
				this.clearSelected()
			}
		},
		return_date(val) {
			if (this.flightsGoing[0]) {
				this.clearSelected()
				this.lookingForReturn = false
			}
		}
	},
	props: {
		forceShowCarouselWeeks: {
			type: Boolean,
			requiered: false,
			default: true
		},
		showTitle: {
			type: Boolean,
			requiered: false,
			default: true
		},
		showOD: {
			type: Boolean,
			requiered: false,
			default: true
		},
		showPassengers: {
			type: Boolean,
			requiered: false,
			default: true
		},
		showTimeLine: {
			type: Boolean,
			requiered: false,
			default: true
		},
		showActionButton: {
			type: Boolean,
			requiered: false,
			default: true
		},
		dismissSummary: {
			type: Boolean,
			requiered: false,
			default: false
		},
		disableAnimations: {
			type: Boolean,
			requiered: false,
			default: false
		},
		customApiGet: {
			type: Function,
			required: false,
			default: axios.get
		},
		customApiPost: {
			type: Function,
			required: false,
			default: axios.post
		},
		loadingMutationName: {
			type: String,
			required: false,
			default: 'setLoading'
		},
		customSummary: {
			required: false,
			type: Object,
			default: () => {
				return briefSummary
			}
		},
		urls: {
			required: true,
			type: Object
		},
		locale: {
			required: false,
			type: String,
			default: null
		},
		showFamilyFareRules: {
			type: Boolean,
			required: false,
			default: false
		},
		includeSearcher: {
			type: Boolean,
			required: false,
			default: false
		},
		useVueAffix: {
			required: false,
			default: true
		},
		isKiuClick: {
			required: false,
		},
		showCalendar: {
			type: Boolean,
			requiered: false,
			default: false
		},
		dateFormat: {
			required: false,
			default: 'DD-MM-YYYY'
		},
		isReturn: {
			required: false
		}
	},
	data() {
		return {
			days: [],
			flightSelected: {},
			flightReturnSelected: {},
			return_date: null,
			departure_date: null,
			summaryKey: 0,
			flightsSource: {},
			currency: this.setCurrency(),
			filters: {
				show: false,
				schedule: [0, 24],
				scheduleIni: [0, 24],
				prices: [0, 10000],
				pricesIni: [0, 10000],
				onlyAvailable: true,
				combinations: false,
				classes: {}
			},
			summaryAction: {
				show: true
			},
			summaryBehavior: this.$store.state.systemStore.summaryBehavior,
			moment: moment,
			loadSummary: false,
			flightsGoing: [],
			flightsReturn: [],
			soldOutFareConfig: {},
			airPriceControl: false,
			airPriceError: false,
			isLoading: false,
			dateNoData: false,
			noFlightsError: false,
			lookingForReturn: false,
			informationText: '',
			carouselWeeks: {
				arrival_week: {},
				return_week: {}
			},
			showCarouselWeeks: false,
			showCarouselDepartureFlight: false,
			showCarouselArrivalFlight: false,
			showCarouselLowerFare: false,
			returnJourneysAvailableFares: {},
			notListedFares: [],
			goingToPassengers: false,
			timeline: new TimelineLite({paused: true}),
			headers: [],
			currentKey: 0,
			sessionId: this.$store.state.systemStore.sessionId,
			isShoppingLoading: false,
			familyFareRules: {},
			onlineInformation: {},
			promoCodeInformation: {}
		}
	},
	mounted() {
		console.info(`%cKIUSYS: Powered by shopping-lib v${version}`, 'color: purple; font-weight:bold')
		if (this.useVueAffix) {
			Vue.use(Affix)
		}
		// axios.defaults.headers.common['Authorization'] = 'Token ' + 'fake-test-key.f4KPkAe73B8'
		if (this.isKiuClick) {
			axios.defaults.headers['Authorization'] = 'Token ' + this.sessionId
			axios.defaults.headers['Carrier'] = this.carrier
		} else {
			axios.defaults.headers.common['Authorization'] = 'Token ' + this.sessionId
		}

		// this.departure_date = moment(this.search.departure_date, [this.dateFormat]).toDate()
		// if (this.search.return_date) {
		//   this.return_date = moment(this.search.return_date, [this.dateFormat]).toDate()
		// }
		this.callFlightInfo()
		this.$store.commit('summaryBehaviorHandler', {
			state: 'absolute',
			continueButton: true,
			showSummary: false
		}, {module: 'systemStore'})
	},
	methods: {
		returnInput($value) {
			if (this.flightSelected.flight && this.search.return_flight && this.lookingForReturn) {
				this.flightReturnSelected = $value
			}
			if (!this.dismissSummary) {
				// this.$store.commit('summaryBehaviorHandler', { state: 'absolute', continueButton: false, showSummary: true }, { module: 'systemStore' })
			}
			setTimeout(() => {
				this.summaryKey++
			}, 0)
		},
		setSearch() {
			this.search = this.$store.getters.getSearchData
		},
		hideMeOnLoad() {
			// var initResultsDeparture = new TimelineMax()
			//   .fromTo('.flights', 0.3, { opacity: 1 }, { opacity: 0 })
			// console.log(initResultsDeparture)
		},
		beforeAnimate() {
			// var initResultsDeparture = new TimelineMax()
			//   .fromTo('#app', 0.1, { opacity: 1 }, { opacity: 0 })
			// console.log(initResultsDeparture)
		},
		initAnimation() {
			if (!this.isLoading && !this.disableAnimations) {
				// setTimeout(() => {
				//   var initResultsDeparture = new TimelineMax()
				//     .to('#app', 0.3, { opacity: 1 })
				//     .to('.flights', 0.3, { opacity: 1 })
				//     .fromTo('.headerNav', 0.3, { y: '-52px', opacity: 0 }, { y: '0px', opacity: 1 })
				//     .fromTo('.flights', 0.3, { opacity: 0 }, { opacity: 1 })
				//     .fromTo('.main-title', 0.3, { opacity: 0 }, { opacity: 1 })
				//     .fromTo('.grid-7x7__flights-actions', 0.4, { opacity: 0 }, { opacity: 1 })
				//     .fromTo('.grid-7x7__fares-header', 0.4, { opacity: 0 }, { opacity: 1 })
				//     .staggerFromTo('.grid-7x7__shallow', 0.5, { opacity: 0, scaleY: 0 }, { opacity: 1, scaleY: 1, ease: Power4.easeOut }, 0.1)
				//     .staggerFromTo('.grid-7x7__flight', 0.2, { opacity: 0, x: '-100px' }, { opacity: 1, x: 0 }, 0.2)
				//   console.log(initResultsDeparture)
				// }, 250)
			}
		},
		clearSelected(dir, event) {
			this.flightSelected = {
				flight: null,
				price: null
			}
			this.flightReturnSelected = {
				flight: null,
				price: null
			}
		},
		setCurrency() {
			if (this.flightsGoing) {
				return this.flightsGoing[0] ? this.flightsGoing[0].rbds[0].currency.split('_')[0] : ''
			} else {
				return ''
			}
		},
		selectFlight(flight) {
			if (this.lookingForReturn) {
				this.flightReturnSelected = flight
				this.$emit('selectFlight', {going: this.flightSelected, return: this.flightReturnSelected})
				return
			}
			this.flightSelected = flight

			this.$emit('selectFlight', {going: this.flightSelected, return: this.flightReturnSelected})

			this.summaryKey++
		},
		callAvailableDates() {
			let send = {
				return_date: this.return_date ? moment(this.return_date).format(this.dateFormat) : null,
				departure_date: moment(this.departure_date).format(this.dateFormat)
			}

			this.$emit('masterFetch', {
				url: `${process.env.apiUrl}/week/`,
				method: 'post',
				vars: send,
				onSuccess: (res) => {
					this.carouselWeeks = res
				},
				onCatch: (err) => {
					console.log('Error fetching available dates', err)
				},
				onFinally: () => {
				}
			})
		},
		changeDepartureDate(val) {
			this.departure_date = moment(val, [this.dateFormat]).toDate()
			this.clearSelected()
		},
		callWeekApi(end, send, arrivalWeek) {
			this.$emit('masterFetch', {
				url: end,
				method: 'post',
				vars: send,
				onSuccess: (res) => {
					if (arrivalWeek) {
						this.carouselWeeks.arrival_week = res
					} else {
						this.carouselWeeks.return_week = res
					}
				},
				onCatch: (err) => {
					console.log('Error fetching available dates', err)
				},
				onFinally: () => {
				}
			})
		},
		changeDate(val, valueReturn) {
			this.isShoppingLoading = true
			this.$store.commit(this.loadingMutationName, true)
			// this.$store.commit('setLoading', true)
			if (val && valueReturn) {
				//Es la opcion de la grilla de 49 combinaciones ida y vuelta
				this.return_date = valueReturn
				this.search.return_date = this.moment(valueReturn, ['YYYY-MM-DD']).format(this.dateFormat)
				if (this.moment(this.search.departure_date, [this.dateFormat]).format('YYYY-MM-DD') >
					this.moment(this.search.return_date, [this.dateFormat]).format('YYYY-MM-DD')) {
					this.search.departure_date = this.search.return_date
					this.departure_date = this.moment(this.search.departure_date, [this.dateFormat]).format('YYYY-MM-DD')
				} else {
					this.departure_date = this.moment(this.search.departure_date, [this.dateFormat]).format('YYYY-MM-DD')
				}
				this.departure_date = val
				this.search.departure_date = this.moment(val, ['YYYY-MM-DD']).format(this.dateFormat)
				if (this.search.return_date) {
					if (this.moment(this.search.departure_date, [this.dateFormat]).format('YYYY-MM-DD') >
						this.moment(this.search.return_date, [this.dateFormat]).format('YYYY-MM-DD')) {
						this.search.return_date = this.search.departure_date
					}
					this.return_date = this.moment(this.search.return_date, [this.dateFormat]).format('YYYY-MM-DD')
				}
			} else if (this.flightSelected.flight && this.search.return_flight && this.lookingForReturn) {
				this.return_date = val
				this.search.return_date = this.moment(val, ['YYYY-MM-DD']).format(this.dateFormat)
				if (this.moment(this.search.departure_date, [this.dateFormat]).format('YYYY-MM-DD') >
					this.moment(this.search.return_date, [this.dateFormat]).format('YYYY-MM-DD')) {
					this.search.departure_date = this.search.return_date
					this.departure_date = this.moment(this.search.departure_date, [this.dateFormat]).format('YYYY-MM-DD')
				} else {
					this.departure_date = this.moment(this.search.departure_date, [this.dateFormat]).format('YYYY-MM-DD')
				}
			} else {
				this.departure_date = val
				this.search.departure_date = this.moment(val, ['YYYY-MM-DD']).format(this.dateFormat)
				if (this.search.return_date) {
					if (this.moment(this.search.departure_date, [this.dateFormat]).format('YYYY-MM-DD') >
						this.moment(this.search.return_date, [this.dateFormat]).format('YYYY-MM-DD')) {
						this.search.return_date = this.search.departure_date
					}
					this.return_date = this.moment(this.search.return_date, [this.dateFormat]).format('YYYY-MM-DD')
				}
			}
			/*
			if (this.flightSelected.price && !this.return_date) {
				this.departure_date = val
			} else if (this.flightSelected.price) {
				this.return_date = val
			} else {
				this.departure_date = val
			}
		*/
			let data = {
				departure_date: this.departure_date,
				return_date: this.return_date
			}
			this.lookingForReturn = false
			const url = `${this.$store.getters.getConfigUrls.apiUrl}reload/`

			this.customApiPost(
				url,
				data
			).then((res) => {
				if (res.data.response) {
					this.clearSelected()
					this.handleResponseFlightInfo(res.data.response)
					this.currentKey = this.currentKey + 1
				}
			}).catch(error => {
				console.error('shopping exception', error)
				this.$emit('shoppingException')
				this.setSearch()
				this.clearSelected()
				this.noFlightsError = true
				this.flightsGoing = []
				this.$nextTick(() => {
					this.initAnimation()
				})
			}).finally(() => {
				this.$emit('back')
				this.$store.commit(this.loadingMutationName, false)
				this.isShoppingLoading = false
			})
		},
		handleChangeDate($value) {
			if (this.flightSelected.flight && this.search.return_flight && this.lookingForReturn) {
				this.changeReturnDate($value)
			} else {
				this.changeDepartureDate($value)
			}
		},
		changeReturnDate(val) {
			this.return_date = moment(val, [this.dateFormat]).toDate()
			this.clearSelected()
		},
		haveCarouselWeeks() {
			return Boolean(this.carouselWeeks)
		},
		getPreviousDate(isGoing) {
			// TODO: get other weeks
			let send = this.carouselWeeks.arrival_week[0]
			if (!isGoing) {
				send = this.carouselWeeks.return_week[0]
				send.going_date = moment(this.departure_date).format(this.dateFormat)
			}
			let end = `${process.env.apiUrl}/get_previous_week/`
			this.callWeekApi(end, send, isGoing)
		},
		getNextDate(isGoing) {
			// TODO: get other weeks
			let send = this.carouselWeeks.arrival_week[this.carouselWeeks.arrival_week.length - 1]
			if (!isGoing) {
				send = this.carouselWeeks.return_week[this.carouselWeeks.return_week.length - 1]
				send.going_date = moment(this.departure_date).format(this.dateFormat)
			}
			let end = `${process.env.apiUrl}/get_next_week/`
			this.callWeekApi(end, send, isGoing)
		},
		compareForGoing(date, dateReturn) {
			if (dateReturn && date < dateReturn) {
				return false
			}
			return true
		},
		compareForReturn(date, dateGoing) {
			if (date > dateGoing) {
				return false
			}
			return true
		},
		verifyWasmExpired(res) {
			if (res.configs.wasmdead === true) {
				this.noFlightsError = true
				this.$nextTick(() => {
					this.initAnimation()
				})
			}
		},
		handleResponseFlightInfo(res) {
			this.setSearch()
			this.$store.commit(this.loadingMutationName, false)
			this.beforeAnimate()
			this.handleConfigs(res)
			this.noFlightsError = false
			this.$nextTick(() => {
				this.initAnimation()
			})
			if (!this.isKiuClick)
				this.verifyWasmExpired(res)
			this.filters.classes = res.family_fares
			this.airports = res.airports

			this.promoCodeInformation = get(res, 'extra_searcher_criteria.promo_code_information', {})

			this.flights = res.first_journeys
			this.journeys = res.first_journeys

			this.flightsGoing = res.first_journeys

			this.onlineInformation = get(res, 'online_information', {})

			this.journeysSource = []
			this.familyFares = []
			this.airPriceControl = []

			if (this.flightsGoing[0] && !this.noFlightsError) {
				const availableCurr = res.family_fares.find(fam => {
					if (res.journeys[res.first_journeys[0]].fares[fam]) {
						return res.journeys[res.first_journeys[0]].fares[fam].currency_reference_id
					}
				})
				this.currency = res.journeys[res.first_journeys[0]].fares[availableCurr].currency_reference_id.split('_')[0]
				this.flightsSource = res.flights
				this.journeysSource = res.journeys
				this.familyFares = res.family_fares
				this.airPriceControl = this.flights.air_price_control
				// otherArgs debería traer del backend información de country settings, promo code, etc
			} else {
				this.currency = get(this.search, 'country_setting.currency_code', 'USD')
				this.noFlightsError = true
			}
			this.callAvailableDates()
			this.loadSummary = true
		},
		callFlightInfo() {
			this.isShoppingLoading = true
			this.clearSelected()
			// this.hideMeOnLoad()
			this.$store.commit(this.loadingMutationName, true)
			let flightPromise
			if (process.env.VUE_APP_FAKE_RESPONSE_NAME) {
				flightPromise = promiseBuilder(process.env.VUE_APP_FAKE_RESPONSE_NAME)
			} else {
				flightPromise = this.customApiGet(
					`${this.urls.configsUrl}`
				)
			}
			flightPromise.then(res => {
				res = res.data.response
				this.$emit('flightInfo', res)
				this.handleResponseFlightInfo(res)
			}).catch((err) => {
				// handle get availability error
				console.error('shopping exception', err)
				this.$emit('shoppingException')
				this.setSearch()
				console.log(err)
				this.noFlightsError = true
				this.flightsGoing = []
				this.$nextTick(() => {
					this.initAnimation()
				})
			}).finally(() => {
				this.isShoppingLoading = false
				this.$store.commit(this.loadingMutationName, false)
			})
		},
		handleConfigs(res) {
			this.showCarouselWeeks = false
			this.carouselWeeks.arrival_week = get(res.carousel, 'going', [])
			this.carouselWeeks.return_week = get(res.carousel, 'return', [])

			if (!this.isKiuClick) {
				this.showCarouselWeeks = res.configs.carousel.show_departure_flight || res.configs.carousel.show_arrival_flight
				this.showCarouselDepartureFlight = res.configs.carousel.show_departure_flight
				this.showCarouselArrivalFlight = res.configs.carousel.show_arrival_flight
				this.showCarouselLowerFare = res.configs.carousel.lower_fare
			}

			if (this.forceShowCarouselWeeks) {
				this.showCarouselWeeks = true
				this.showCarouselDepartureFlight = true
				this.showCarouselArrivalFlight = true
				this.showCarouselLowerFare = true
			}

      this.dateNoData = res.date_no_data
      // * dejo esto acá para tenerlo en mente en el momento de hacer que las reglas
      //   de familias tarifarias se traigan del backend, por ahora, están hardcodeadas
      this.familyFareRules = Object.freeze(this.getFamilyFareRules(res)) // non reacting & performance
      this.soldOutFareConfig = {
        'show_amount_crossed_out': get(res.configs, 'soldout_fare.soldout_fare_amount_crossed_out', true),
        'show_amount_in_table': get(res.configs, 'soldout_fare.soldout_fare_amount_in_table', true)
      }

			if (get(res, 'configs.bottom_message')) {
				this.$emit('bottomMessageConfig', res.configs.bottom_message)
			}

		},
		setInformationText() {
			let informationText = this.flights.information_text
			let informationMockText = null
			if (informationText) {
				informationMockText = this.$i18nParse(informationText, this.$i18n.locale)
			}
			this.informationText = informationMockText
		},
		getRbdTitleTranslation(rbd) {
			return this.$i18nParse(rbd.title, this.$i18n.locale, rbd.reference)
		},
		sweptAnimation(reverse = false) {
			if (this.disableAnimations) {
				return
			}

			this.timeline.set(
				'.newCurtain',
				{transformOrigin: reverse ? 'center right' : 'center left', scaleX: '0', ease: Power4.easeOut}).to(
				'.newCurtain',
				0.5,
				{
					transformOrigin: reverse ? 'center left' : 'center right',
					scaleX: '1',
					ease: Power4.easeOut
				}).set('.newCurtain',
				{transformOrigin: reverse ? 'center right' : 'center left'}).to('.newCurtain', 0.35, {
					scaleX: '0',
					ease: Power4.easeOut
				}
			)
			this.timeline.play()
		},
		continueBooking() {
			const returnCondition = !this.lookingForReturn && this.search.return_date && this.flightSelected

			if (returnCondition) {
				this.searchReturn()
				return
			}

			this.goingToPassengers = true

			let selectedJourneys = []

			selectedJourneys.push({
				journey_code: this.flightSelected.journeyName,
				family_fare: this.flightSelected.fare.name
			})

			if (this.flightReturnSelected.journeyName) {
				selectedJourneys.push({
					journey_code: this.flightReturnSelected.journeyName,
					family_fare: this.flightReturnSelected.fare.name
				})
			}

			const sendData = {
				selected_journeys: selectedJourneys,
				session_key: this.sessionId,
				finalLists: {
					finalList: this.theFinalList,
					finalReturnList: this.theFinalReturnList
				},
				flightSelected: this.flightSelected,
				flightReturnSelected: this.flightReturnSelected
			}

			localStorage.setItem('flightSelected', JSON.stringify(this.flightSelected))
			if (this.flightReturnSelected.flight) {
				localStorage.setItem('flightReturnSelected', JSON.stringify(this.flightReturnSelected))
				sendData.flightReturnSelected = this.flightReturnSelected
			}

			this.$store.commit(this.loadingMutationName, true)

			this.customApiPost(
				`${this.$store.getters.getConfigUrls.apiUrl}action/`,
				sendData
			).then(res => {
				this.$store.commit(this.loadingMutationName, true)
				this.$store.dispatch('goNextSpa')
			}).catch(err => {
				console.log(err)
				this.$store.commit(this.loadingMutationName, false)
			})
		},
		goBack(dir, event) {
			this.clearSelected()
			this.lookingForReturn = false
			this.notListedFares = []
			if (!this.isLoading && !this.disableAnimations) {
				this.sweptAnimation(true)
			}
			this.currentKey += 1
			this.$nextTick(() => {
				this.$emit('back')
			})
		},
		formatFlightDataToComplete(flight) {
			let flightData = {
				origin: flight.flight.origin,
				destination: flight.flight.destination,
				airline: flight.flight.airline,
				arrival_datetime: flight.flight.arrival_datetime,
				departure_datetime: flight.flight.departure_datetime,
				flight_number: flight.flight.flight_number,
				rbd_data: flight.price,
				direct: flight.flight.direct,
				stops: flight.flight.stops
			}
			return flightData
		},
		toggleSummary() {
			if (!this.dismissSummary) {
				this.$store.commit('summaryBehaviorHandler', {state: 'relative'}, {module: 'systemStore'})
			}
		},
		getReturnFlights() {
			if (this.journeysSource) {
				const returnJourneys = Object.keys(this.flightSelected.flight.fares[this.flightSelected.price].next)
				returnJourneys.forEach(journey => {
					let availableFares = this.flightSelected.flight.fares[this.flightSelected.price].next[journey]
					this.returnJourneysAvailableFares[journey] = availableFares
				})
				this.flightsReturn = returnJourneys
			}
		},
		searchReturn() {
			this.sweptAnimation()
			this.$emit('toggleSummary')
			this.getReturnFlights()
			this.$emit('continueButtonHit')
      setTimeout(() => {
        this.lookingForReturn = true
        this.currentKey = this.currentKey + 1
      }, 500)
    },
    getFamilyFareRules (data) {
      const firstKey = Object.keys(data.family_fares_information)[0]
      const familyFares = get(data, `family_fares_information.${firstKey}.kiu_shopping_brand_definition`)
      if (!familyFares) console.error('Error in family fares conditions. Please check api price')
      return familyFares
    }
  }
}
